/**
 * Versioning rules (spec section 5):
 * - Default action is "save as new version".
 * - A version may be edited in place only if it has no tastings.
 */
export function canEditInPlace(tastingCount: number): boolean {
  return tastingCount === 0;
}

export function nextVersionNumber(existing: number[]): number {
  return existing.length === 0 ? 1 : Math.max(...existing) + 1;
}
